import {
    owaConnectedAccountAdded,
    owaAccountStoreInitializationFailed,
} from '../actions/publicActions';
import {
    addOWAConnectedAccount as addOWAConnectedAccountToStore,
    OWAConnectedAccount,
    isOWAConnectedAccountValid,
} from 'owa-accounts-store';
import { getConnectedAccountRequestOptions } from 'owa-connected-account-headers';
import { getUserMailboxInfo } from 'owa-client-ids';
import getOwaUserConfigurationOperation from 'owa-service/lib/operation/getOwaUserConfigurationOperation';
import { setUserConfiguration } from 'owa-session-store';
import { getMailboxRequestOptions, MailboxRequestOptions } from 'owa-request-options-types';

/**
 * Adds the account to the `owa-account-store`, fetches the accounts user configuration data/
 * adds it to the session store, and finally dispatches the `owaConnectedAccountAdded` action when
 * this is complete
 * @param account account to be initialized
 */
export async function initializeOwaConnectedAccountInternal(
    account: OWAConnectedAccount,
    isRetry: boolean
): Promise<void> {
    const { userIdentity, accountProviderType } = account;

    try {
        addOWAConnectedAccountToStore(account);

        const mailboxInfo = getUserMailboxInfo(userIdentity);
        const requestOptions = await getConnectedAccountRequestOptions(
            getMailboxRequestOptions(mailboxInfo)! as MailboxRequestOptions
        );

        // If fetching the refresh token fails while getting the request options, then the connected
        // account is marked as invalid, so we need to also check this before we call getOwaUserConfig
        // for this account
        const isAccountValid = isOWAConnectedAccountValid(userIdentity);

        if (requestOptions.headers && isAccountValid) {
            // $TODO VSO 58329: we need to figure out when to retry this call if it fails.
            const userConfiguration = await getOwaUserConfigurationOperation(requestOptions);

            setUserConfiguration(userConfiguration, userIdentity);
            owaConnectedAccountAdded(userIdentity, accountProviderType);
        } else {
            const error = !requestOptions.headers ? 'Missing headers' : 'Account invalid ';
            owaAccountStoreInitializationFailed(userIdentity, isRetry, accountProviderType, error);
        }
    } catch (error) {
        const errorMessage = 'Exception' + error;
        owaAccountStoreInitializationFailed(
            userIdentity,
            isRetry,
            accountProviderType,
            errorMessage
        );
    }
}
